const sports = [
	{name: 'Acrobatics', id: 'acrobatics'},
	{name: 'Archery', id: 'archery'},
	{name: 'Badminton', id: 'badminton'},
	{name: 'Baseball', id: 'baseball'},
	{name: 'Basketball', id: 'basketball'},
	{name: 'Bass Fishing', id: 'bass-fishing'},
	{name: 'Beach Volleyball', id: 'beach-volleyball'},
	{name: 'Bowling', id: 'bowling'},
	{name: 'Cross Country', id: 'cross-country'},
	{name: 'Cycling', id: 'cycling'},
	{name: 'Equestrian', id: 'equestrian'},
	{name: 'Fencing', id: 'fencing'},
	{name: 'Field Hockey', id: 'field-hockey'},
	{name: 'Football', id: 'football'},
	{name: 'Golf', id: 'golf'},
	{name: 'Gymnastics', id: 'gymnastics'},
	{name: 'Ice Hockey', id: 'ice-hockey'},
	{name: 'Lacrosse', id: 'lacrosse'},
	{name: 'Power Lifting', id: 'power-lifting'},
	{name: 'Rifle', id: 'rifle'},
	{name: 'Rodeo', id: 'rodeo'},
	{name: 'Rowing', id: 'rowing'},
	{name: 'Rugby', id: 'rugby'},
	{name: 'Sailing', id: 'sailing'},
	{name: 'Shooting / Shotgun', id: 'shooting-shotgun'},
	{name: 'Skiing', id: 'skiing'},
	{name: 'Soccer', id: 'soccer'},
	{name: 'Softball', id: 'softball'},
	{name: 'Sprint Football', id: 'sprint-football'},
	{name: 'Squash', id: 'squash'},
	{name: 'Swimming & Diving', id: 'swimming-diving'},
	{name: 'Synchronized Swimming', id: 'synchronized-swimming'},
	{name: 'Tennis', id: 'tennis'},
	{name: 'Track & Field', id: 'track-field'},
	{name: 'Triathlon', id: 'triathlon'},
	{name: 'Volleyball', id: 'volleyball'},
	{name: 'Water Polo', id: 'water-polo'},
	{name: 'Wrestling', id: 'wrestling'}
];

export default sports;
